import { z } from 'zod';

export const AsanaGidSchema = z.string().regex(/^\d+$/, 'Expected an Asana ID');
export const AsanaResourceSchema = z.object({ gid: AsanaGidSchema, name: z.string() });
export const AsanaProjectSchema = AsanaResourceSchema.extend({
  archived: z.boolean(),
  workspace: z.object({ gid: AsanaGidSchema }),
});
export const AsanaScopeSchema = z.object({
  workspaceGid: AsanaGidSchema,
  projects: z.array(AsanaProjectSchema).min(1).max(100),
});
export const AsanaStorySchema = z.object({
  gid: AsanaGidSchema,
  created_at: z.string().datetime(),
  created_by: AsanaResourceSchema.nullable(),
  resource_subtype: z.string(),
  text: z.string().optional(),
});
export const AsanaTaskSchema = AsanaResourceSchema.extend({
  notes: z.string(),
  completed: z.boolean(),
  created_at: z.string().datetime(),
  modified_at: z.string().datetime(),
  assignee: AsanaResourceSchema.nullable(),
  workspace: z.object({ gid: AsanaGidSchema }),
  projects: z.array(AsanaResourceSchema),
  permalink_url: z.string().url().refine(value => {
    const url = new URL(value);
    return url.protocol === 'https:' && url.hostname === 'app.asana.com';
  }, 'Expected an Asana task URL'),
});
export const AsanaCollectedTaskSchema = AsanaTaskSchema.extend({ stories: z.array(AsanaStorySchema) });
export type AsanaProject = z.infer<typeof AsanaProjectSchema>;
export type AsanaScope = z.infer<typeof AsanaScopeSchema>;
export type AsanaCollectedTask = z.infer<typeof AsanaCollectedTaskSchema>;
